const ATTACH_PRESENTABLE_TO_STREAM_CONDUCTOR = 'ATTACH_PRESENTABLE_TO_STREAM_CONDUCTOR'
const DETACH_PRESENTABLE_FROM_STREAM_CONDUCTOR = 'DETACH_PRESENTABLE_FROM_STREAM_CONDUCTOR'
const SET_ACTIVE_PRESENTABLE = 'SET_ACTIVE_PRESENTABLE'
const SET_QUEUED_PRESENTABLE = 'SET_QUEUED_PRESENTABLE'
const PRESENTABLE_PRESENT_AS_CHANGED = 'PRESENTABLE_PRESENT_AS_CHANGED'

const RESOURCE_TABLE_DELETE_RESOURCE = 'RESOURCE_TABLE_DELETE_RESOURCE'
const RESOURCE_TABLE_EDIT_RESOURCE = 'RESOURCE_TABLE_EDIT_RESOURCE'
const NEW_RESOURCE_CREATED = 'RESOURCE_TABLE_EDIT_RESOURCE'
const RESOURCE_TABLE_RELOAD = 'RESOURCE_TABLE_RELOAD'

const DELETE_PRESENTABLE = 'DELETE_PRESENTABLE'
const REDIRECT_TO_EDIT_PRESENTABLE = 'REDIRECT_TO_EDIT_PRESENTABLE'
const TOGGLE_LIVESTREAM_ENABLE_REPLAY = 'TOGGLE_LIVESTREAM_ENABLE_REPLAY'

const ATTACH_REACTION_TO_STREAM_CONDUCTOR = 'ATTACH_REACTION_TO_STREAM_CONDUCTOR'
const DETACH_REACTION_FROM_STREAM_CONDUCTOR = 'DETACH_REACTION_FROM_STREAM_CONDUCTOR'

// mux asset index
const DELETE_MUX_ASSET = 'DELETE_MUX_ASSET'

const TOGGLE_ACTIVE_ETAG  = 'TOGGLE_ACTIVE_ETAG'
const UPDATE_ETAG         = 'UPDATE_ETAG'

export const REFRESH_STREAM_CONDUCTOR_PRESENTER = 'REFRESH_STREAM_CONDUCTOR_PRESENTER'

export default {
  ATTACH_PRESENTABLE_TO_STREAM_CONDUCTOR,
  DETACH_PRESENTABLE_FROM_STREAM_CONDUCTOR,
  SET_ACTIVE_PRESENTABLE,
  SET_QUEUED_PRESENTABLE,
  PRESENTABLE_PRESENT_AS_CHANGED,
  RESOURCE_TABLE_DELETE_RESOURCE,
  RESOURCE_TABLE_EDIT_RESOURCE,
  RESOURCE_TABLE_RELOAD,
  NEW_RESOURCE_CREATED,
  DELETE_PRESENTABLE,
  REDIRECT_TO_EDIT_PRESENTABLE,
  REFRESH_STREAM_CONDUCTOR_PRESENTER,
  ATTACH_REACTION_TO_STREAM_CONDUCTOR,
  DETACH_REACTION_FROM_STREAM_CONDUCTOR,
  TOGGLE_LIVESTREAM_ENABLE_REPLAY,
  DELETE_MUX_ASSET,
  TOGGLE_ACTIVE_ETAG,
  UPDATE_ETAG
}